<template>
  <v-divider class="border-opacity-100 w-50 mx-auto" style="max-width: 500px;" color=primary thickness=2 />
</template>